import React from 'react';

export default props => (
  <svg {...props}>
    {props.children}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.28 7.3a4.8 4.8 0 0 1 9.53-.8l.1.63h.71a3.88 3.88 0 0 1 0 7.75v1.5a5.38 5.38 0 0 0 .54-10.73A6.3 6.3 0 0 0 3.79 7.8a4.45 4.45 0 0 0 1.66 8.59h.92v-1.5h-.92a2.95 2.95 0 0 1-.66-5.83l.7-.16-.13-.7a4.83 4.83 0 0 1-.08-.89Zm8.44 9.24-1.97 1.93v-7h-1.5v7l-1.97-1.93-1.05 1.08 3.25 3.17c.29.28.75.28 1.04 0l3.25-3.17-1.05-1.08Z"
    />
  </svg>
);
